import { createCredits } from '@actions/createCredits'
import { saveOnboardingAnswers } from '@actions/saveOnboardingAnswers'
import Layout from '@app-studio-web/ui/components/Layout'
import Spinner from '@app-studio-web/ui/components/Spinner'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function PreparingPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [isSaved, setIsSaved] = useState(false)
  const [isCredit, setIsCredit] = useState(false)

  // Effect for saving answers and creating credits
  useEffect(() => {
    const run = async () => {
      const [saveAnswers, createCredit] = await Promise.all([
        saveOnboardingAnswers(),
        createCredits(),
      ])
      setIsSaved(saveAnswers.success)
      setIsCredit(createCredit.success)
    }

    run()
  }, [])

  // Effect for navigation after saving
  useEffect(() => {
    if (!isSaved || !isCredit) return

    const timeout = setTimeout(() => {
      navigate('/checkout/plans')
    }, 3000)

    return () => clearTimeout(timeout)
  }, [isSaved, navigate, isCredit])

  return (
    <Layout>
      <div className="flex h-full flex-col items-center justify-center">
        <div className="w-full max-w-xs space-y-5 p-8 text-center">
          <h1 className="custom-heading text-3xl">
            {t('pages.signUp.loading.heading')}
          </h1>

          <p className="text-xl">
            {t('pages.signUp.loading.analyzingResponses')}
          </p>
          <Spinner />
        </div>
      </div>
    </Layout>
  )
}
